import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Root shell — un `router-outlet` directo, sin dependencias de auth.
 *
 * El gate de autenticación que vivía acá (spinner mientras `authStatus()`
 * era `bootstrapping`) se movió a `AuthGateComponent` y se monta SOLO sobre
 * las superficies autenticadas (`/admin` y `/auth`, ambas CSR — ver
 * `app.routes.ts`). El storefront público SSR renderiza contenido sin pasar
 * por el ciclo de vida de auth: el shell raíz no inyecta `AuthService`, así
 * el server jamás dispara el bootstrap de sesión para un visitante anónimo
 * ni serializa markup/estilos del gate en el HTML público.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class App {}
